import React from "react";

export default function PrivacyPolicy() {
  return (
    <div
      style={{
        maxWidth: "900px",
        margin: "80px auto",
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        lineHeight: "1.6",
        color: "#333",
      }}
    >
      <h1 style={{ color: "#2874F0", textAlign: "center", marginBottom: "20px" }}>
        Privacy Policy
      </h1>

      <p>Last Updated: Jan 2025</p>

      <p>
        This Privacy Policy explains how <strong>Sangitshree Prakashan</strong> collects,
        uses, and safeguards your information when you use our website and mobile application.
      </p>

      <h3 style={{ color: "#2874F0", marginTop: "20px" }}>Information We Collect</h3>
      <p>We may collect the following user information:</p>
      <ul>
        <li>Name</li>
        <li>Email Address</li>
        <li>Phone Number</li>
        <li>Order Details</li>
      </ul>

      <h3 style={{ color: "#2874F0", marginTop: "20px" }}>How We Use Your Information</h3>
      <ul>
        <li>To manage your account</li>
        <li>To process and deliver your orders</li>
        <li>To provide customer support</li>
        <li>To improve our services and app performance</li>
      </ul>

      <h3 style={{ color: "#2874F0", marginTop: "20px" }}>Data Sharing</h3>
      <p>
        We do <strong>not</strong> share your personal information with any third-party company,
        advertiser, or external organization. Your data is used only for app functionality.
      </p>

      <h3 style={{ color: "#2874F0", marginTop: "20px" }}>Data Security</h3>
      <p>
        All your data is encrypted during transfer. We take reasonable measures to protect your
        information from unauthorized access.
      </p>

      <h3 style={{ color: "#2874F0", marginTop: "20px" }}>Account & Data Deletion</h3>
      <p>You may request deletion of your account and data anytime using the link below:</p>

      <a
        href="/profile"
        style={{ color: "#2874F0", fontWeight: "bold" }}
      >
        https://sangitshreeprakashan.com/profile
      </a>

      <p>
        After your request, your account and associated data will be permanently deleted from
        our system within a reasonable time.
      </p>

      <h3 style={{ color: "#2874F0", marginTop: "20px" }}>Children's Privacy</h3>
      <p>
        Our services are intended only for users above 18 years old. We do not knowingly
        collect data from minors.
      </p>

      <h3 style={{ color: "#2874F0", marginTop: "20px" }}>Changes to This Policy</h3>
      <p>
        We may update this Privacy Policy from time to time. Continued use of our services
        means you accept the updated policy.
      </p>

      <h3 style={{ color: "#2874F0", marginTop: "20px" }}>Contact Us</h3>
      <p>
        Email: <strong>sangitshreeprakashan@gmail.com</strong><br />
        Phone: <strong>+91 7408452828</strong>
      </p>
    </div>
  );
}
